export class WorksheetShareModel {
  Id?: Number;
  UserName: string;
  Title: string;
  Assets: AssetWks[];
  ComponentType: string;
  Type: number;
}

export class AssetWks {
  symbol: string;
  company: string;
}
